module.exports = __webpack_public_path__ + "img/top_up.bee3ca84.svg";